// Modules
import { reduxForm, Field } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CompanySelect } from 'components/forms/selects';
import { DateInput, TextAreaInput } from 'components/forms/form-elements';
import { Form } from 'components/forms/form-structure';
import { handleServerError } from 'utils/form-utils';
import requiredValidation from 'utils/required-validation';


// Component
function WatchForm(props) {
  return (
    <Form preventAutoFocus onSubmit={props.handleSubmit} {..._.pick(props, ['submitting', 'error', 'submitFailed'])}>
      <Field component={DateInput} name="date" label="Date" />
      <Field component={CompanySelect} name="company" label="Company" />
      <Field component={TextAreaInput} name="notes" label="Notes" />
    </Form>
  );
}

WatchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  change: PropTypes.func
};

export default reduxForm({
  form: 'form-form',
  validate: (values) => requiredValidation(['notes', 'date'], values),
  onSubmitFail: handleServerError
})(WatchForm);
